var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDotedCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 0.5H1.99219C0.887618 0.5 -0.0078125 1.39543 -0.0078125 2.5V14.5C-0.0078125 15.6046 0.887618 16.5 1.99219 16.5H13.9922C15.0968 16.5 15.9922 15.6046 15.9922 14.5V2.5C15.9922 1.39543 15.0968 0.5 13.9922 0.5ZM0.992188 4.35714C0.992188 3.88376 1.4399 3.5 1.99219 3.5H13.9922C14.5445 3.5 14.9922 3.88376 14.9922 4.35714V14.6429C14.9922 15.1162 14.5445 15.5 13.9922 15.5H1.99219C1.4399 15.5 0.992188 15.1162 0.992188 14.6429V4.35714Z",
    fill: "#878A99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49219 7.5C7.04447 7.5 7.49219 7.05228 7.49219 6.5C7.49219 5.94772 7.04447 5.5 6.49219 5.5C5.9399 5.5 5.49219 5.94772 5.49219 6.5C5.49219 7.05228 5.9399 7.5 6.49219 7.5Z",
    fill: "#878A99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 7.5C10.0445 7.5 10.4922 7.05228 10.4922 6.5C10.4922 5.94772 10.0445 5.5 9.49219 5.5C8.9399 5.5 8.49219 5.94772 8.49219 6.5C8.49219 7.05228 8.9399 7.5 9.49219 7.5Z",
    fill: "#878A99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 7.5C13.0445 7.5 13.4922 7.05228 13.4922 6.5C13.4922 5.94772 13.0445 5.5 12.4922 5.5C11.9399 5.5 11.4922 5.94772 11.4922 6.5C11.4922 7.05228 11.9399 7.5 12.4922 7.5Z",
    fill: "#878A99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49219 10.5C4.04447 10.5 4.49219 10.0523 4.49219 9.5C4.49219 8.94772 4.04447 8.5 3.49219 8.5C2.9399 8.5 2.49219 8.94772 2.49219 9.5C2.49219 10.0523 2.9399 10.5 3.49219 10.5Z",
    fill: "#878A99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49219 10.5C7.04447 10.5 7.49219 10.0523 7.49219 9.5C7.49219 8.94772 7.04447 8.5 6.49219 8.5C5.9399 8.5 5.49219 8.94772 5.49219 9.5C5.49219 10.0523 5.9399 10.5 6.49219 10.5Z",
    fill: "#878A99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 10.5C10.0445 10.5 10.4922 10.0523 10.4922 9.5C10.4922 8.94772 10.0445 8.5 9.49219 8.5C8.9399 8.5 8.49219 8.94772 8.49219 9.5C8.49219 10.0523 8.9399 10.5 9.49219 10.5Z",
    fill: "#878A99"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 10.5C13.0445 10.5 13.4922 10.0523 13.4922 9.5C13.4922 8.94772 13.0445 8.5 12.4922 8.5C11.9399 8.5 11.4922 8.94772 11.4922 9.5C11.4922 10.0523 11.9399 10.5 12.4922 10.5Z",
    fill: "#878A99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49219 13.5C4.04447 13.5 4.49219 13.0523 4.49219 12.5C4.49219 11.9477 4.04447 11.5 3.49219 11.5C2.9399 11.5 2.49219 11.9477 2.49219 12.5C2.49219 13.0523 2.9399 13.5 3.49219 13.5Z",
    fill: "#878A99"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49219 13.5C7.04447 13.5 7.49219 13.0523 7.49219 12.5C7.49219 11.9477 7.04447 11.5 6.49219 11.5C5.9399 11.5 5.49219 11.9477 5.49219 12.5C5.49219 13.0523 5.9399 13.5 6.49219 13.5Z",
    fill: "#878A99"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49219 13.5C10.0445 13.5 10.4922 13.0523 10.4922 12.5C10.4922 11.9477 10.0445 11.5 9.49219 11.5C8.9399 11.5 8.49219 11.9477 8.49219 12.5C8.49219 13.0523 8.9399 13.5 9.49219 13.5Z",
    fill: "#878A99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDotedCalendar);
export default __webpack_public_path__ + "static/media/gray-doted-calendar.34cfd77c1a58259cf152ebb5f06e548b.svg";
export { ForwardRef as ReactComponent };